import React from 'react'

const AccessTokenContext = React.createContext(null);

export const AccessTokenProvider = AccessTokenContext.Provider;

export default AccessTokenContext;